import { render } from "./TextSingleComponent.vue?vue&type=template&id=603a5934&ts=true"
import script from "./TextSingleComponent.vue?vue&type=script&lang=ts"
export * from "./TextSingleComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__